export default __webpack_public_path__ + "static/media/pic7.860ebe5d.jpg";